import script from "./ViewPaymentComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPaymentComponent.vue?vue&type=script&setup=true&lang=js"

import "./ViewPaymentComponent.vue?vue&type=style&index=0&id=db22d6c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db22d6c6"]])

export default __exports__